import {Button, Stack} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import SurveyInviteDialog from './SurveyInviteDialog';

/**
 * A guest profile's survey action: the invite dialog with the guest already chosen. On the profile page's Forms and
 * Surveys tab, and in the shared profile dialog (as `extraActions`, next to Marketing, Bookings and Folios).
 */
export default function SurveyInviteButton({profileId}: {profileId?: string}) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <Stack direction={'row'} gap={1}>
            <Button variant={'outlined'} disabled={!profileId} onClick={() => setOpen(true)}>
                {t('Create survey link')}
            </Button>
            {/* Mounted only while open, so every opening starts from this guest afresh. */}
            {open && <SurveyInviteDialog open onClose={() => setOpen(false)} profileId={profileId}/>}
        </Stack>
    );
}
